import { filterToCondition } from "../db_utils";
import { TableDef } from "../table_def";
import { toDateTimeString } from "../date_utils";
import { useContext, useEffect, useState } from "react";
import { Context } from "../context";
import * as FC from "@fluentui/react-components";
import { getCurrentUser } from "./login";
import { apiClient } from "./api";

const user_searchable_columns = [
    "account",
    "name",
    "department",
    // "description",
];

export const listUser = async (db, filter) => {
    try {
        const params = {};
        if (filter) {
            params.filter = filter;
        }
        const response = await apiClient.getUsers(params);
        return response || [];
    } catch (error) {
        console.error("Failed to list users:", error);
        return [];
    }
};

const roleDisplayMap = {
    Admin: "管理员",
    admin: "管理员",
    QA: "质检员",
    Rechecker: "复检员",
    Annotator: "标注员",
    FieldOperator: "现场操作员",
    field_admin: "现场操作员",
    BackendOperator: "后台操作员",
    staff: "后台操作员",
    operator: "后台操作员",
};

const formatGroupLabel = (group) => {
    if (!group) {
        return "";
    }
    if (roleDisplayMap[group]) {
        return roleDisplayMap[group];
    }
    const lower = typeof group === "string" ? group.toLowerCase() : group;
    return roleDisplayMap[lower] || group;
};

export const UserDef = new TableDef("user", {
    account: {
        label: "用户名",
    },
    name: {
        label: "姓名",
    },
    department: {
        label: "部门",
    },
    role: {
        label: "角色",
        display: (item) => {
            if (Array.isArray(item.groups) && item.groups.length) {
                const displayGroups = item.groups
                    .map((group) => formatGroupLabel(group))
                    .filter(Boolean);
                if (displayGroups.length) {
                    return displayGroups.join("、");
                }
            }
            return formatGroupLabel(item.role) || "-";
        },
    },
    disabled: {
        label: "状态",
        display: (item) => (item.disabled && "禁用") || "正常",
    },
    updated_at: {
        label: "更新时间",
        display: (item) => toDateTimeString(item.updated_at),
    },
    last_login_at: {
        label: "最后登录",
        display: (item) => toDateTimeString(item.last_login_at),
    },
    description: {
        label: "备注",
    },
});

/**
 * @param {import("@fluentui/react-components").DropdownProps} props
 */
export const UserDropdown = (props) => {
    const { db } = useContext(Context);
    let [users, setUsers] = useState([]);
    let refresh = async () => {
        if (!db) {
            return;
        }
        const users = await listUser(db, null);
        setUsers(users);
    };
    useEffect(() => {
        refresh();
    }, [db]);
    let options = [
        { value: "", text: "全部" },
        ...users.map((it) => ({ value: it.id, text: it.name })),
    ];
    return (
        <FC.Dropdown {...props}>
            {options.map((option) => (
                <FC.Option key={option.value} value={option.value}>
                    {option.text}
                </FC.Option>
            ))}
        </FC.Dropdown>
    );
};
